import { ReactNode, useContext } from "react";
import { cn } from "@/utils/classes";
import { TabsContext } from "./tabs-context";

/* Prop Types */
export interface TabPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  value: string | number;
  children: ReactNode;
}

/*
 * TabPanel Component
 *
 * Content container for tab panels
 */
export const TabPanel = ({ value, children, className, ...props }: TabPanelProps) => {
  /* Context */
  const context = useContext(TabsContext);

  if (!context) {
    throw new Error("TabPanel must be used within a Tabs component");
  }

  /* Consts */
  const { activeTab } = context;
  const isActive = activeTab === value;

  if (!isActive) return null;

  /* Return */
  return (
    <div {...props} className={cn("tab-content", className)} role="tabpanel">
      {children}
    </div>
  );
};
